export default "__VITE_ASSET__DBhFNN55__"